const sendExternalEvent = (category, action, label) => {
  // eslint-disable-next-line no-undef
  dataLayer.push({
    GAEventBridgeAction: action,
    GAEventBridgeCategory: category,
    GAEventBridgeLabel: label,
  });
  // eslint-disable-next-line no-undef
  dataLayer.push({ event: "GAEventBridge", "gtm.uniqueEventId": 1 });
};

export default sendExternalEvent;
